import { registerPlugin } from '@capacitor/core';
import type { DeviceInitializerPluginDef, LogPluginDef, OfflineSyncPluginDef, QueryResolverPluginDef } from './definitions';

export const DeviceInitializerPlugin = registerPlugin<DeviceInitializerPluginDef>('DeviceInitializerPlugin');
export const QueryResolverPlugin = registerPlugin<QueryResolverPluginDef>('QueryResolverPlugin');
export const OfflineSyncPlugin = registerPlugin<OfflineSyncPluginDef>('OfflineSyncPlugin');
export const LogPlugin = registerPlugin<LogPluginDef>('LogPlugin');
